import sticky_footer_cta_init from './sticky_footer_cta/init';

export default function footer_init() {
    sticky_footer_cta_init();
    scroll_to_top_btn_init();

    document.addEventListener('toggle_height_init', close_footer_dropdowns);

    document.addEventListener('DOMContentLoaded', close_footer_dropdowns);

    window.addEventListener('resize', close_footer_dropdowns);
}

function scroll_to_top_btn_init() {
    const buttons = document.querySelectorAll('.scroll_to_top_btn');
    if (!buttons.length) return;

    buttons.forEach(btn => {
        btn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });
    });
}

function close_footer_dropdowns() {
    if (window.innerWidth > 768) return;

    document.querySelectorAll('.elementor-location-footer .ff_toggle_height').forEach(container => {
        if (container.ff_toggle_height && typeof container.ff_toggle_height.close === 'function') {
            container.ff_toggle_height.close();
        } else {
            const trigger = container.querySelector('.ff_toggle_height_trigger');
            const target = container.querySelector('.ff_toggle_height_target');
            const toggleCon = container.querySelector('.toggle_con');

            if (trigger) trigger.classList.remove('open');
            if (target) target.classList.remove('open');
            if (toggleCon) toggleCon.style.height = '0px';
        }
    });
}
